<template>

  <md-button
    class="md-primary"
    @click="$emit('click', $event)"
    :disabled="disabled || loading">

    <!-- spinner -->
    <md-progress-spinner v-if="loading"
      :md-diameter="17"
      :md-stroke="2"
      md-mode="indeterminate"
      class="no-fade-out"
      />

    <!-- icon -->
    <md-icon v-else>{{ icon }}</md-icon>

    <!-- text -->
    <div><slot /></div>

    <!-- Tooltip -->
    <md-tooltip v-if="toolTipText != ''" :md-direction="toolTipDirection">
      {{ toolTipText }}
    </md-tooltip>
  </md-button>

</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    toolTipText: {
      type: String,
      default: ''
    },
    toolTipDirection: {
      type: String,
      default: 'top'
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.md-button {
  &:not(.md-simple) .md-progress-spinner {
    color: $color-text-on-dark !important;
  }

  & .md-progress-spinner {
    margin-right: 7px;
    margin-left: -7px;
  }
  & .md-icon {
    margin-left: -7px;
  }
}

</style>
